import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NewscommentService {

  constructor( private http: HttpClient) { }
  public CommentID = "";
  public CommentType = ""
  GetAllNewsComments(req) {
      return this.http.get(environment.apiURL + `newscomment/GetAllNewsComment`, {params: req});    
  }

  GetNewsComments(NewsID)
  {
    return this.http.get(environment.apiURL + `newscomment/GetAllNewsComment?IsAdminCommented=false&NewsId=`+NewsID);   
  }

  GetProductComments(ProductID)
  {
    return this.http.get(environment.apiURL + `newscomment/GetAllNewsComment?IsAdminCommented=false&ProductId=`+ProductID);   
  }

  GetRepoComments(RepoID)
  {
    return this.http.get(environment.apiURL + `newscomment/GetAllNewsComment?IsAdminCommented=false&RepoId=`+RepoID);   
  }

  GetComments(ID,Type)
  {
    if(Type == "Repository"){
      return this.http.get(environment.apiURL + `newscomment/GetAllNewsComment?IsAdminCommented=false&RepoId=`+ID); 
    }
    else if(Type == "News"){
      return this.http.get(environment.apiURL + `newscomment/GetAllNewsComment?IsAdminCommented=false&NewsId=`+ID); 
    }
    else if(Type == "Product"){
      return this.http.get(environment.apiURL + `newscomment/GetAllNewsComment?IsAdminCommented=false&ProductId=`+ID); 
    }
    

  }

  SaveAdminComments(data)
  {
    return this.http.post(environment.apiURL + `newscomment/AddAdminComment`, data);
  }

  SaveUserComments(data){
    return this.http.post(environment.apiURL + `newscomment/AddNewsComment`, data);
  }

  GetUserComments(data){
    return this.http.post(environment.apiURL + `newscomment/GetNewsComment`, data);
  }  

  GetNewsReplyData(NewsID)
  {
    return this.http.get(environment.apiURL + `newscomment/GetAllNewsComment?NewsId=`+NewsID);   
  }

  GetProductReplyData(ProductID)
  {
    return this.http.get(environment.apiURL + `newscomment/GetAllNewsComment?ProductId=`+ProductID);   
  }

  GetRepoReplyData(RepoID)
  {
    return this.http.get(environment.apiURL + `newscomment/GetAllNewsComment?RepoId=`+RepoID);   
  }

  GetReplyData(ID,Type)
  {
    if(Type == "Repository"){
      return this.http.get(environment.apiURL + `newscomment/GetAllNewsComment?RepoId=`+ID);   
    }
    else if(Type == "News"){
      return this.http.get(environment.apiURL + `newscomment/GetAllNewsComment?NewsId=`+ID);  
    }
    else if(Type == "Product"){
      return this.http.get(environment.apiURL + `newscomment/GetAllNewsComment?ProductId=`+ID);   
    }
    

  }
}
